module.exports = __webpack_public_path__ + "59f32353.svg";